"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = exports.SIZE = exports.APPEARANCES = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Ellipsis = _interopRequireWildcard(require("../common/Ellipsis"));
var _HeadingSt = require("./Heading.st.css");
var _EllipsisCommon = require("../common/PropTypes/EllipsisCommon");
var _deprecationLog = _interopRequireDefault(require("../utils/deprecationLog"));
var _context = require("../WixStyleReactMaskingProvider/context");
var _context2 = require("../WixStyleReactProvider/context");
var _ZIndex = require("../ZIndex");
var _excluded = ["light", "ellipsis", "appendTo", "flip", "fixed", "placement", "zIndex", "enterDelay", "exitDelay", "showTooltip"],
  _excluded2 = ["appearance", "as", "children", "dataHook", "size", "id", "light"];
var _jsxFileName = "/home/builduser/work/b60d7defec63c7cc/packages/wix-style-react/dist/cjs/Heading/Heading.js";
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var APPEARANCES = exports.APPEARANCES = {
  H1: 'H1',
  H2: 'H2',
  H3: 'H3',
  H4: 'H4',
  H5: 'H5',
  H6: 'H6'
};
var SIZE = exports.SIZE = {
  EXTRA_LARGE: 'extraLarge',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  TINY: 'tiny',
  EXTRA_TINY: 'extraTiny'
};
var sizeToAppearance = {
  [SIZE.EXTRA_LARGE]: APPEARANCES.H1,
  [SIZE.LARGE]: APPEARANCES.H2,
  [SIZE.MEDIUM]: APPEARANCES.H3,
  [SIZE.SMALL]: APPEARANCES.H4,
  [SIZE.TINY]: APPEARANCES.H5,
  [SIZE.EXTRA_TINY]: APPEARANCES.H6
};
var Heading = _ref => {
  var {
      light = false,
      ellipsis = false,
      appendTo = _Ellipsis.default.defaultProps.appendTo,
      flip = _Ellipsis.default.defaultProps.flip,
      fixed = _Ellipsis.default.defaultProps.fixed,
      placement = _Ellipsis.default.defaultProps.placement,
      zIndex = _Ellipsis.default.defaultProps.zIndex,
      enterDelay = _Ellipsis.default.defaultProps.enterDelay,
      exitDelay = _Ellipsis.default.defaultProps.exitDelay,
      showTooltip = _Ellipsis.default.defaultProps.showTooltip
    } = _ref,
    propsWithNoDefaults = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var props = _objectSpread(_objectSpread({}, _Ellipsis.default.defaultProps), {}, {
    light,
    ellipsis,
    appendTo,
    flip,
    fixed,
    placement,
    zIndex,
    enterDelay,
    exitDelay,
    showTooltip
  }, propsWithNoDefaults);
  var {
    ellipsisProps,
    componentProps
  } = (0, _Ellipsis.extractEllipsisProps)(props);
  var {
      appearance,
      as,
      children,
      dataHook,
      size,
      id,
      light: _light
    } = componentProps,
    headingProps = (0, _objectWithoutProperties2.default)(componentProps, _excluded2);
  (0, _react.useEffect)(() => {
    if (appearance) {
      (0, _deprecationLog.default)('<Heading/> - prop "appearance" is deprecated and will be removed in next major release, please use "size" property instead.');
    }
  }, [appearance]);
  var headingType = sizeToAppearance[size] || appearance || sizeToAppearance[SIZE.EXTRA_LARGE];
  return /*#__PURE__*/_react.default.createElement(_context.WixStyleReactMaskingContext.Consumer, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 5
    }
  }, _ref2 => {
    var {
      maskingClassNames
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_context2.WixStyleReactContext.Consumer, {
      __self: void 0,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 91,
        columnNumber: 9
      }
    }, _ref3 => {
      var {
        newColorsBranding
      } = _ref3;
      return /*#__PURE__*/_react.default.createElement(_Ellipsis.default, (0, _extends2.default)({}, ellipsisProps, {
        wrapperClassName: (0, _HeadingSt.st)(_HeadingSt.classes.root, {
          appearance: headingType,
          size: newColorsBranding ? size : undefined
        }),
        render: _ref4 => {
          var {
            ref,
            ellipsisClasses,
            ellipsisInlineStyle
          } = _ref4;
          return /*#__PURE__*/_react.default.createElement(as || headingType.toLowerCase(), _objectSpread(_objectSpread({}, headingProps), {}, {
            id,
            ref,
            style: ellipsisInlineStyle,
            'data-hook': dataHook,
            className: (0, _HeadingSt.st)(_HeadingSt.classes.root, {
              light,
              appearance: headingType,
              newColorsBranding
            }, ellipsisClasses(props.className), maskingClassNames),
            'data-appearance': appearance,
            'data-size': size,
            'data-light': light,
            'data-mask': !!maskingClassNames,
            'data-id': id
          }), children);
        },
        __self: void 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 93,
          columnNumber: 13
        }
      }));
    });
  });
};
Heading.displayName = 'Heading';
Heading.propTypes = _objectSpread(_objectSpread({}, _EllipsisCommon.EllipsisCommonProps), {}, {
  /** When true, text that is longer than it's container will be truncated to a single line followed by ellipsis. Otherwise the text will break into several lines. */
  ellipsis: _propTypes.default.bool,
  /** maxLines truncates text at a specific number of lines. */
  maxLines: _propTypes.default.number,
  /** Applies a data-hook HTML attribute that can be used in the tests. */
  dataHook: _propTypes.default.string,
  /** Renders any kind of content within a heading. Usually it’s a text string. */
  children: _propTypes.default.any,
  /** Invert heading style so it can be used on a dark or image background. */
  light: _propTypes.default.bool,
  /** this prop is deprecated and should not be used
   * @deprecated
   */
  appearance: _propTypes.default.oneOf(Object.keys(APPEARANCES)),
  /** Renders the heading as any other given HTML tag */
  as: _propTypes.default.string,
  /** Controls the heading's visual size and HTML tag appearance. HTML tag can be overridden with ‘as’ prop. */
  size: _propTypes.default.oneOf(Object.values(SIZE)),
  /** Identifies the element that labels or describes the text element */
  id: _propTypes.default.string
});
var _default = exports.default = Heading;
//# sourceMappingURL=Heading.js.map